import * as Preact from "preact"
import * as gameicons from "@iconify-json/game-icons"

export default class Icon {
    render() {
        if(this.props.icon != undefined) {
            return (
                <div class="Icon" style={{
                    "background-image": "url(" + this.props.icon + ")"
                }}/>
            )
        }

        if(this.props.iconKey != undefined
        && gameicons.icons.icons[this.props.iconKey] != undefined) {
            return (
                <svg viewBox="0 0 512 512" class="Icon">
                    <g color="#000" dangerouslySetInnerHTML={{"__html": gameicons.icons.icons[this.props.iconKey].body}}/>
                </svg>
            )
        }
    }
}
